<template>
  <div class="tiger-footer">
    <div class="flex-row footer-top-wrapper">
      <tiger-title>
        <template slot="cn">
          <p>潘虎设计实验室</p>
        </template>
      </tiger-title>
      <div style="line-height: 0"
           :style="footerLogoStyle"
           v-intersect="{class: 'my-animated-comm animate__fadeInUp'}">
        <svg-icon iconClass="footer-tiger-logo" className="footer-tiger-logo"></svg-icon>
      </div>
    </div>
    <div class="flex-row footer-bottom-wrapper">
      <div class="footer-info-frame" v-intersect="{class: 'my-animated-comm animate__fadeInUp'}">
        <p class="cn-22-thin" style="line-height: 1.5; font-size: min(.23rem, 22px)">{{ portalInfo.address }}</p>
        <p class="cn-22-thin" style="line-height: 1.5; font-size: 0">
          <router-link to="/works">
            <span class="cn-22-thin" style="line-height: 1.5; font-size: min(.25rem, 24px)">作品透视</span>
          </router-link>
          <span class="cn-22-thin" style="line-height: 1.5; font-size: min(.25rem, 24px)">｜</span>
          <router-link to="/contact">
            <span class="cn-22-thin" style="line-height: 1.5; font-size: min(.23rem, 22px)">取得联系</span>
          </router-link>
          <span class="cn-22-thin" style="line-height: 1.5; font-size: min(.23rem, 22px)">｜</span>
          <span @click="dialogVisible = true"
                class="cn-22-thin"
                style="line-height: 1.5; font-size: min(.25rem, 24px); cursor: pointer">招聘信息</span>
          <span class="cn-22-thin" style="line-height: 1.5; font-size: min(.25rem, 24px)">｜</span>
          <router-link to="/about">
            <span class="cn-22-thin" style="line-height: 1.5; font-size: min(.25rem, 24px)">关于我们</span>
          </router-link>
        </p>
        <p class="cn-22-thin" style="line-height: 1.5; font-size: min(.23rem, 22px); color: rgba(255,255,255,.4)">
          <a href="https://beian.miit.gov.cn"
             style="color: rgba(255,255,255,.4)">{{ portalInfo.icp }}</a> {{ portalInfo.copyright }}
        </p>
      </div>
      <div class="footer-business-frame" v-intersect="{class: 'my-animated-comm animate__fadeInUp'}">
        <p v-pre class="cn-22-thin" style="line-height: 1.5; font-size: min(.23rem, 22spx)">商务合作</p>
        <div class="flex-row footer-business-box">
          <div v-for="business in businessList" :key="business.id">
            <p class="cn-22-thin"
               style="line-height: 1.5; font-size: min(.23rem, 22px)">{{ business.duty }} {{ business.name }}</p>
            <p class="cn-22-thin"
               style="line-height: 1.5; font-size: min(.23rem, 22px)">{{ business.phone }}</p>
          </div>
        </div>
      </div>
      <div class="footer-social-frame"
           :style="footerSocialStyle" v-intersect="{class: 'my-animated-comm animate__fadeInUp'}">
        <template v-for="(linkPath, name, index) in socialInfo">
          <el-popover v-if="name === 'wechat' && linkPath !== ''" trigger="hover">
            <img :src="linkPath" style="width: 120px; height: auto" alt="">
            <svg-icon slot="reference"
                      :iconClass="index === hoverIndex ? name + '-cover' : name"
                      className="footer-social-logo"
                      @mouseenter.native="hoverIndex = index"
                      @mouseout.native="hoverIndex = -1"></svg-icon>
          </el-popover>
          <svg-icon v-else v-else-if=" linkPath !== ''"
                    :iconClass="index === hoverIndex ? name + '-cover' : name"
                    className="footer-social-logo"
                    :linkPath="linkPath"
                    @mouseenter.native="hoverIndex = index"
                    @mouseout.native="hoverIndex = -1"></svg-icon>
        </template>
      </div>
    </div>
    <div class="flex-row job-wrapper" v-show="dialogVisible" @click="handleJobWrapperClick">
      <img id="job-img" :src="job" alt="">
    </div>
  </div>
</template>

<script>
import TigerTitle from '@/components/TigerTitle';
import {fetchPortalMap} from "@/api/system";
import {fetchAllBusiness} from "@/api/business";
import {fetchSocialMap} from "@/api/system";
import {resize} from "@/utils/resize";
import TigerDynamic from "@/components/TigerDynamic";

export default {
  name: "TigerFooter",

  components: {TigerDynamic, TigerTitle},

  mixins: [resize],

  data() {
    return {
      portalInfo: {},
      businessList: [],
      socialInfo: {
        wechat: '',
        weibo: '',
        tiktok: '',
        red: '',
        zcool: '',
        behance: '',
        facebook: '',
        instagram: ''
      },
      job: '',
      dialogVisible: false,
      hoverIndex: -1
    }
  },

  methods: {
    handleJobWrapperClick(e) {
      const id = e.target.id;
      if (id && id.indexOf('job-img') > -1) {
        return;
      }
      this.dialogVisible = false;
    },

    getPortalInfo() {
      fetchPortalMap().then(response => {
        this.portalInfo = response.data || {};
      })
    },

    getBusinessList() {
      fetchAllBusiness().then(response => {
        this.businessList = response.data || [];
      })
    },

    getSocialInfo() {
      fetchSocialMap().then(response => {
        let temp = response.data || {};
        if (temp !== {}) {
          Object.assign(this.socialInfo, temp);
          this.job = temp.job;
        }
      })
    }
  },

  computed: {
    footerLogoStyle() {
      return {
        // paddingTop: this.calcToPx(.34, 48, 96),
        paddingRight: this.calcToPx(.5, 48, 96)
      };
    },

    footerSocialStyle() {
      return {
        '--gap': this.calcToPx(.167, 48, 96),
        '--col': this.calcToPx(.333, 48, 96)
      };
    }
  },

  mounted() {
    this.getPortalInfo();
    this.getBusinessList();
    this.getSocialInfo();
  }
}
</script>

<style lang="scss" scoped>
.tiger-footer {
  width: 100vw;
  min-width: 960px;
  background-color: $col-primary-black;
  padding: .625rem;

  .footer-top-wrapper {
    justify-content: space-between;
    height: 2.625rem;

    .footer-tiger-logo {
      width: .833rem;
      max-width: 80px;
      height: .740rem;
      max-height: 72px;
    }
  }

  .footer-bottom-wrapper {
    justify-content: space-between;
    align-items: flex-end;

    .footer-info-frame {
      width: 6.25rem;
      height: 1.125rem;
      max-height: 108px;
    }

    .footer-business-frame {
      width: 5.417rem;
      height: 1.125rem;
      max-height: 108px;

      .footer-business-box {
        justify-content: space-between;
      }
    }

    .footer-social-frame {
      display: grid;
      grid-template-columns: repeat(4, var(--col));
      grid-column-gap: var(--gap);
      grid-row-gap: var(--gap);
      width: 1.833rem;
      max-width: 176px;
      height: .833rem;
      max-height: 80px;
      list-style: none;
      margin: 0;
      padding: 0;

      span {
        font-size: .333rem;
        line-height: 0;
      }

      .footer-social-logo {
        width: .333rem;
        max-width: 32px;
        height: .333rem;
        max-height: 32px;
      }
    }
  }

  .job-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.85);
    justify-content: center;
    align-items: center;

    #job-img {
      width: auto;
      height: 95%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TigerFooter.vue